/**
 *
 * ItemPageScoring
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import UserAndExpertRating from 'components/UserAndExpertRating';
import _isEmpty from 'lodash/isEmpty';

const styles = () => ({
  root: {
    marginTop: 20,
  },
});

function ItemPageScoring(props) {
  const { classes, data, type, hasUserLink, hideExpertRating } = props;
  if (_isEmpty(data)) return null;
  return (
    <Grid item xs={12} className={classes.root}>
      <UserAndExpertRating
        data={data[0].fields}
        isBig
        type={type}
        hasUserLink={hasUserLink}
        hideExpertRating={hideExpertRating}
        isItemPage
      />
    </Grid>
  );
}

ItemPageScoring.propTypes = {
  classes: PropTypes.object,
  data: PropTypes.array,
  type: PropTypes.string,
  hasUserLink: PropTypes.bool,
  hideExpertRating: PropTypes.bool,
};

export default withStyles(styles)(ItemPageScoring);
